
export default {
  name: 'InfiniteScroll',
  props: {
    disabledScroll: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      observer: null,
      popup: false,
      popScrollTarget: '.el-dialog__body'
    }
  },
  mounted () {
    this.observer = new IntersectionObserver((entries) => {
      this.handleIntersect(entries[0])
    }, {
      root: null,
      threshold: [0.5, 0.75, 1.0],
    })
    this.createObserve()
  },
  beforeDestroy () {
    this.observer.disconnect()
  },
  methods: {
    createObserve () {
      this.observer.observe(this.$refs.infiniteTrigger)
    },
    handleIntersect (entry) {
      if (
        entry.isIntersecting &&
        this.disabledScroll === false
      ) {
        this.checkPopup()
        if (this.popup && this.$refs.infiniteTrigger.closest(this.popScrollTarget).scrollTop > 0) {
          console.log('observer emit from popup')
          this.$emit('scrollEnd', this.$refs.infiniteTrigger)
        } else if (!this.popup && window.scrollY > (window.innerHeight / 2)) {
          console.log('observer emit from wrap')
          this.$emit('scrollEnd', this.$refs.infiniteTrigger)
        }
      }
    },
    checkPopup () {
      if (this.$refs.infiniteTrigger.closest('.el-dialog') !== null) {
        this.popup = true
        if (this.$refs.infiniteTrigger.closest('.pop-scroll') !== null) {
          this.popScrollTarget = '.pop-scroll'
        }
      } else {
        this.popup = false
      }
    }
  },
}
